
<div class="row">

    <div class="col-12" *ngIf="attributeGroups">

        <div class="title-tools">

            <div class="check-all-attributes-action_tools pointer" style="margin-right: 98px;">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" name="select_read_edit" id="select_read_edit" type="checkbox"  
                    (change)="getAccessToAllAttributes($event, 'edit', 'all')"
                    [(ngModel)]="attributeAccessAllEdit"> 
                    <label class="custom-control-label" for="select_read_edit">
                        разрешить редактировать и просматривать все
                    </label>
                </div>
            </div>

            <div class="check-all-attributes-action_tools pointer">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" name="select_only_read" id="select_only_read" type="checkbox" 
                    (change)="getAccessToAllAttributes($event, 'read', 'all')"
                    [(ngModel)]="attributeAccessAllRead"> 
                    <label class="custom-control-label" for="select_only_read">
                        разрешить просматривать все
                    </label>
                </div>
            </div>

        </div>

        <div class="card">
    
            <!-- left list -->
            <ul>
                <!-- attribute -->

                <div class="attributes-and-groups-data" *ngFor="let attrGroup of attributeGroups; let i = index"> 

                    <div class="attribute-group">

                        <div class="check-all-attributes-action pointer">
                            <div class="custom-control custom-checkbox">
                                <input 
                                    tooltipClass="clue-name" 
                                    ngbTooltip="Редактирование и просмотр"
                                    class="custom-control-input"
                                    type="checkbox" 
                                    name="select_all_attr_access_edit{{i}}"
                                    id="select_all_attr_access_edit{{i}}"
                                    [checked]="attrGroup.edit"
                                    [indeterminate]="checkedButNotAllCheckBox(i)"
                                    (change)="attrGroup.isOpen = !attrGroup.isOpen; prepariedAttributesList($event, i, 'edit', attrGroup.id, attrGroup.isOpen)">
                                <label class="custom-control-label" for="select_all_attr_access_edit{{i}}"></label>
                            </div>
                        </div>

                        <!-- <span class="check-all-attributes-action pointer" tooltipClass="clue-name" ngbTooltip="Редактирование и просмотр">
                            <input 
                            type="checkbox" 
                            name="select_all_attr_access_edit"
                            id="select_all_attr_access_edit"
                            (change)="attrGroup.isOpen = !attrGroup.isOpen; prepariedAttributesList($event, i, 'edit', attrGroup.id, attrGroup.isOpen)"
                            [indeterminate]="checkedButNotAllCheckBox(i)"
                            [checked]="attrGroup.edit"
                            >
                        </span> -->

                        <div class="check-all-attributes-action pointer">
                            <div class="custom-control read custom-checkbox">
                                <input class="custom-control-input" 
                                    type="checkbox" 
                                    name="select_all_attr_access_read{{i}}"
                                    id="select_all_attr_access_read{{i}}" 
                                    [checked]="attrGroup.read"
                                    (change)="attrGroup.isOpen = !attrGroup.isOpen; prepariedAttributesList($event, i, 'read', attrGroup.id, attrGroup.isOpen)">
                                <label class="custom-control-label" for="select_all_attr_access_read{{i}}"></label>
                            </div>
                        </div>

                        <!-- <span class="check-all-attributes-action pointer" tooltipClass="clue-name" ngbTooltip="Только просмотр">
                            <input type="checkbox" 
                            name="select_all_attr_access_read"
                            id="select_all_attr_access_read"
                            (change)="attrGroup.isOpen = !attrGroup.isOpen; prepariedAttributesList($event, i, 'read', attrGroup.id, attrGroup.isOpen)"
                            [checked]="attrGroup.read">
                        </span> -->

                        <i
                            [ngClass]="attrGroup.isOpen ? 'bi bi-caret-down-fill pointer' : 'bi bi-caret-right-fill pointer'"
                            style="color: var(--grayscale-500);"
                            (click)="attrGroup.isOpen = !attrGroup.isOpen; isOpenItem(attrGroup.id, i, attrGroup.isOpen)">
                        </i>
                        
                        <span>
                            <!-- <img src="/assets/images/file_icons/png/folder.png"> -->
                            <span class="group-name pointer" (click)="attrGroup.isOpen = !attrGroup.isOpen; isOpenItem(attrGroup.id, i, attrGroup.isOpen)">
                                {{ attrGroup.name }} 
                            </span>
                        </span>

                    </div>

                    <li *ngIf="attributes[i]"> 

                        <!-- attribute-name -->
                            <div class="attribute-name-block" *ngFor="let attr of attributes[i]; let j = index"> 

                              <!-- <span>{{ attr.name }} </span>

                              <div class="attribute-action_inner">

                                  <div class="attribute-action">
    
                                    <input type="checkbox" (change)="checkboxEvent($event, attr, 'edit')" [checked]="attr.edit"> (Редактирование и чтение)  
                    
                                  </div>
    
                                  <div class="attribute-action">
    
                                    <input type="checkbox" (change)="checkboxEvent($event, attr, 'read')" [checked]="attr.read"> (Только чтение)  
    
                                  </div>

                              </div> -->

                              

                              <div class="attribute-action_inner">

                                  <div class="attribute-action" tooltipClass="clue-name" container="body" ngbTooltip="Редактирование и просмотр">

                                    <div class="custom-control custom-checkbox">
                                        <input  class="custom-control-input" 
                                        type="checkbox" 
                                        name="attr_edit-{{j}}"
                                        id="attr_edit-{{j}}" 
                                        (change)="checkboxEvent($event, attr, 'edit')" [checked]="attr.edit">
                                        <label class="custom-control-label" for="attr_edit-{{j}}"></label>
                                    </div>
                                    
    
                                    <!-- <input type="checkbox" (change)="checkboxEvent($event, attr, 'edit')" [checked]="attr.edit" tooltipClass="clue-name" ngbTooltip="Редактирование и просмотр"> -->
                    
                                  </div>
    
                                  <div class="attribute-action" tooltipClass="clue-name" container="body" ngbTooltip="Только просмотр">

                                    <div class="custom-control read custom-checkbox">
                                        <input  class="custom-control-input" 
                                        type="checkbox" 
                                        name="attr_read-{{j}}"
                                        id="attr_read-{{j}}" 
                                        (change)="checkboxEvent($event, attr, 'read')" [checked]="attr.read">
                                        <label class="custom-control-label" for="attr_read-{{j}}"></label>
                                    </div>

    
                                    <!-- <input type="checkbox" (change)="checkboxEvent($event, attr, 'read')" [checked]="attr.read" tooltipClass="clue-name" ngbTooltip="Только просмотр"> -->
    
                                  </div>
                                  
                                  <span>{{ attr.name }} </span>

                              </div>

                              
                              
                            </div> 
                    </li>

                    <li *ngIf="checkIsEmpty[i]" class="empty-attributes">
                        Атрибуты отсутствуют
                    </li>
                    
                </div>   
            </ul>
        </div>
    </div>
</div>